module.exports = __webpack_public_path__ + "img/darkblue_line.b04f3c25.png";